import { Component, BaseTLDetailComponent, AxiosResponse, GeneralTermService, GeneralTermFilter, tlDateToISOString, tlISODateTimeToLocalNoSecondsString } from "../../../Infrastructure/CorBase/CoreBase";
	export default abstract class  GeneralTermDetailBase extends BaseTLDetailComponent {

		
		protected generalTermService: GeneralTermService = new GeneralTermService();

		fileContent: File | null = null;

		formData = {
			id: 0,
			idUser:0,
			name: '',
			description: '',
			validFrom: '',
			validTo: '',
			publicationDate:'',
			sendNotification:'',
		    consentDate: '',
			consentUser:''
		};

		createdBase() {
			this.loadMinDateFrom();
		}
		minDate = '';
		loadMinDateFrom() {
			let generalTermFilter: GeneralTermFilter = new GeneralTermFilter(null);
			return this.generalTermService.getAllByFilter(generalTermFilter).then(res => {
				var lastItem = this.findLatestValidFrom(res.data as Array<any>);
				this.minDate = lastItem.validFrom;
			});
		}

		findLatestValidFrom(data:any) {
			return data.reduce((latest:any, current:any) => {
				const currentValidFrom = new Date(current.validFrom);
				const latestValidFrom = new Date(latest.validFrom);

				return currentValidFrom > latestValidFrom ? current : latest;
			}, data[0]);
		}

		consentTerm() {
			this.isBusy = true;
			this.formData.idUser = this.$store.state.idUser;
		
			if (this.formData.validTo.trim()=='') {
				//@ts-ignore
				delete this.formData.validTo;
			}
			this.generalTermService.consentGeneralTerm(this.formData.id, this.formData).then(res => {
				this.processResponse(res);
				this.isBusy = false;
			}).catch(res => { this.isBusy = false; });
		}

		download() {
			this.generalTermService.getOriginalFileById(this.formData.id).then(res => {
				const url = window.URL.createObjectURL(new Blob([res.data], { type: 'application/pdf' }));
				const link = document.createElement('a');
				link.href = url;
				var nameDocument = this.formData.name + '.pdf';
				link.setAttribute('download', nameDocument); // Název souboru pro stažení
				document.body.appendChild(link);
				link.click();
				link.remove();
			});
		}


		private dataToFormData(): FormData {
			let formData: FormData = new FormData();
			formData.append('id', this.formData.id.toString());
			formData.append('name', this.formData.name.toString());
			formData.append('description', this.formData.description.toString());
			formData.append('validFromText', this.formData.validFrom.toString());
			formData.append('sendNotification', new Date(this.formData.sendNotification).toISOString());
			formData.append('validToText', this.formData.validTo);
		
			if (this.fileContent) {
				formData.append('fileContent', this.fileContent, this.fileContent.name);
			}
			return formData;
		}


		protected doAction() {
			super.doCRUDActionWithInfoMessage(this.$t('generalTerm.messageNew').toString(), this.$t('generalTerm.messageEdit').toString(), this.$t('generalTerm.messageDelete').toString());
		}

		protected fetchDataFromServer(): Promise<AxiosResponse<any>> {
			return this.generalTermService.getById(this.objectId);
		}

		protected fetchRefreshDataFromServer(): Promise<AxiosResponse<any>> {
			return super.NoCall()
		}

		protected refreshItems(items: any, refreshData: any): any {
			return items;
		}

		protected processResponse(response: AxiosResponse<any>): void {
			this.formData.id = response.data.id;
			this.formData.name = response.data.name;
			this.formData.description = response.data.description;
			this.formData.validFrom = response.data.validFrom != null ? response.data.validFrom.substring(0, 10) : '';
			this.formData.validTo = response.data.validTo != null ? response.data.validTo.substring(0, 10) : '';
			this.formData.sendNotification = response.data.sendNotification != null ? response.data.sendNotification.substring(0, 10) : '';
			this.formData.publicationDate = response.data.publicationDate != null ? response.data.publicationDate.substring(0, 10) : '';
			this.formData.consentUser = response.data.consentUser;
			this.formData.consentDate = response.data.consentDate != null ? tlISODateTimeToLocalNoSecondsString(response.data.consentDate) : '';
		}


		protected afterCreate(response: AxiosResponse<any>): void {
			this.formData.id = response.data.id;
		}

		protected updateObject(): Promise<AxiosResponse<any>> {
			
			return this.generalTermService.update(this.objectId, this.formData);
		}

		publishTermBase() {
			this.isBusy = true;
			//@ts-ignore
			delete this.formData.validTo;
			//@ts-ignore
			delete this.formData.publicationDate;

			this.generalTermService.publishGeneralTerm(this.formData.id, this.formData).then(res => {
				if (res.data.isSuccess == false) {
					this.showAlertModalWithErrorMessage(res.data.errorMessage);
				}
				this.processResponse(res);
				this.isBusy = false;
			}).catch(res => {
				this.isBusy = false;
			});
		}


		//todo upravit
		protected updateBase() {
			if (this.styleFormNew) {
				this.isBusy = true;
				let formData: FormData = this.dataToFormData();
				this.generalTermService.create(formData).then(res => {
					this.showAlertModalWithInfoMessage(this.$t('generalTerm.messageNew').toString());
					this.formIsInEditMode = false;
					this.mainDataChanged = false;
					this.isBusy = false;
					this.formData.id = res.data.id;
				}).catch(res => {
					this.isBusy = false;
				});
				
			}
			else {
				var result = this.generalTermService.update(this.objectId, this.formData).then(res => {
					if (res.data.isSuccess == false) {
						this.showAlertModalWithTitleAndContent(this.$t('global.titleError').toString(), res.data.errorMessage);
					}
					else {
						this.showAlertModalWithInfoMessage(this.$t('generalTerm.messageEdit').toString());
						this.formIsInEditMode = false;
						//	this.styleFormDetail = false;
					}
				});
			}
			
		}

		protected createObject(): Promise<AxiosResponse<any>> {		
			let formData: FormData = this.dataToFormData();
			return this.generalTermService.create(formData);
		}

		protected deleteObject(): Promise<AxiosResponse<any>> {
			return this.generalTermService.delete(this.objectId);
		}
		
		vIsCorrectName: boolean = true;
		vIsMinDate: boolean = true;
		vIsMaxDate: boolean = true;
		vIsCorrectFile: boolean = true;
		vNotificationDate: boolean = true;

		isCorrectDate = this.formData.validTo == '' || (new Date(this.formData.validFrom) < new Date(this.formData.validTo));
	
		protected validateBase() {
			var isOk = new Date(this.formData.validFrom) > new Date(this.minDate) || this.minDate.length == 0;
		
			return !(this.vIsCorrectName && this.vIsMinDate && this.vIsMaxDate && this.vIsCorrectFile && this.vNotificationDate && this.isCorrectDate && isOk);
		}
		
		protected isCorrectNameBase(value: any) {
			this.vIsCorrectName = value;
		}

		protected isCorrectMinDateBase(value: any) {
			this.vIsMinDate = value;
		}

		protected isCorrectMaxDateBase(value: any) {
			this.vIsMaxDate = value;
		}

		isCorrectFileBase(value: any) {
			this.vIsCorrectFile =  this.styleFormNew ? value : true;
		}

		isCorrectNotificationDateBase(value: any) {
			this.vNotificationDate = value;
		}

	}
